var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.preBookingData
    ? _c(
        "section",
        { ref: "sectionSummaryMobile", staticClass: "section-summary-mobile" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c(
                "div",
                { staticClass: "flex-fill text-remark text-sm text-dark" },
                [
                  _c("div", [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.serviceParentName(
                            _vm.preBookingData.service_id,
                            _vm.globalState.services
                          )
                        )
                      }
                    }),
                    _vm._v(
                      " - \n        " +
                        _vm._s(
                          _vm._f("multiLangName")(
                            _vm.globalState.cities[
                              _vm.preBookingData.province_id
                            ]
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.preBookingData.cleaning_date
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("summaryCleaningDate")(
                                  _vm.preBookingData.cleaning_date
                                )
                              ) +
                              " (" +
                              _vm._s(_vm.preBookingData.cleaning_time) +
                              ")\n        "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "message.booking.new_booking.booking_type_flexible"
                                )
                              ) +
                              "\n        "
                          )
                        ]),
                    _vm._v("\n          -\n        "),
                    _vm.preBookingData.service_id === 1
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  _vm.globalState.allWorkHours[
                                    _vm.preBookingData.work_hour
                                  ]
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm.preBookingData.service_items
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getServiceItemsCount()) +
                              " " +
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.preBookingData.service_items[0].item_unit
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.globalState.services[
                                    _vm.preBookingData.service_id
                                  ]
                                )
                              ) +
                              "\n        "
                          )
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-primary" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("currency")(
                        _vm.state.currentStep === 3
                          ? _vm.totalPrice
                          : _vm.state.totalPrice
                      )
                    ) +
                    "\n    "
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00c8354e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00c8354e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/SummaryBookingSelectProfessional.vue
// module id = 1884
// module chunks = 0